/* OMEXWATCH theme interactions: mobile nav, quantity steppers, image zoom, toast. */
(function () {
  'use strict';

  /* Announcement + header mobile nav */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    var clamp = function () {
      var min = parseInt(input.min || '1', 10);
      var max = parseInt(input.max || '99', 10);
      var v = parseInt(input.value || '1', 10);
      if (isNaN(v)) v = min;
      input.value = Math.min(Math.max(v, min), max);
    };
    if (minus) minus.addEventListener('click', function () { input.stepDown(); clamp(); input.dispatchEvent(new Event('change')); });
    if (plus) plus.addEventListener('click', function () { input.stepUp(); clamp(); input.dispatchEvent(new Event('change')); });
    input.addEventListener('blur', clamp);
  });

  /* Product gallery thumb switcher */
  var main = document.querySelector('[data-gallery-main]');
  if (main) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full') || thumb.src;
        main.alt = thumb.alt || main.alt;
      });
    });
  }

  /* Toast helper */
  var toast = document.querySelector('[data-toast]');
  var toastTimer = null;
  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }
  window.omexToast = showToast;

  /* Ajax add-to-cart on product forms */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-disabled'); btn.disabled = true; }
      fetch(form.getAttribute('action'), {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          showToast('Added to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
          if (btn) { btn.disabled = false; btn.classList.remove('is-disabled'); }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-disabled'); }
          showToast('Could not add to cart — please try again');
        });
    });
  });

  /* Auto-submit sort dropdown */
  var sortSelect = document.querySelector('[data-sort-submit]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
